function appConfigTranslations($translateProvider, CONFIG) {
    'ngInject';

    $translateProvider.useStaticFilesLoader({
        prefix: 'app/assets/translations/locale-',
        suffix: '.json?1647355100'
    });

    $translateProvider.fallbackLanguage(CONFIG.default_locale);
    $translateProvider.use(CONFIG.default_locale);
    $translateProvider.useSanitizeValueStrategy(null);

}

export default appConfigTranslations;


// WEBPACK FOOTER //
// ./client/app/app.config.translations.js